import { useRef } from "react";
import { Trans, useTranslation } from "react-i18next";

import Diligence from "src/core/assets/images/icons/diligence.svg?react";
import HalfPerson from "src/core/assets/images/icons/halfPerson.svg?react";
import Lab from "src/core/assets/images/icons/lab.svg?react";
import Mission from "src/core/assets/images/icons/mission.svg?react";
import People from "src/core/assets/images/icons/people.svg?react";
import { DocumentPreviewModal } from "src/core/components/documents/DocumentPreviewModal";
import { FolderDiligences } from "src/core/components/folder/diligences/FolderDiligences";
import { FolderMissions } from "src/core/components/folder/FolderMissions";
import { FolderQuestionnaireLAB } from "src/core/components/folder/FolderQuestionnaireLAB";
import { MissionLetter } from "src/core/components/folder/missions/MissionLetter";
import { FolderStakeholders } from "src/core/components/folder/stakeholders/FolderStakeholders";
import { useDocumentPreview } from "src/core/contexts/DocumentPreviewContext";
import { useFolder } from "src/core/contexts/FolderContext";

export const FolderElements = () => {
  const diligencesTitleRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();
  const { tabCounters, stakeholdersCounter, isPPH } = useFolder();
  const { documentToPreview, openDocumentPreviewModal, handleOpenDocumentPreviewModal } =
    useDocumentPreview();

  return (
    <div className="flex flex-col gap-y-40">
      <div className="folder-details-one-page-section">
        <div className="folder-details-one-page-title">
          <Mission className="w-20 h-20" />
          {t("folder.missions.sectionTitle")}
          {tabCounters.missions > 0 && (
            <span className="item-counter-tag bg-background-secondary">{tabCounters.missions}</span>
          )}
        </div>
        <MissionLetter />
        <FolderMissions isOnePage />
      </div>
      <div className="folder-details-one-page-section">
        <div className="folder-details-one-page-title">
          {isPPH ? <HalfPerson className="w-20 h-20" /> : <People className="w-20 h-20" />}
          {t(isPPH ? "folder.stakeholders.sectionTitlePPH" : "folder.stakeholders.sectionTitle")}
          {stakeholdersCounter.global > 0 && (
            <span className="item-counter-tag bg-background-secondary">
              {stakeholdersCounter.global}
            </span>
          )}
        </div>
        <FolderStakeholders />
      </div>
      <div className="folder-details-one-page-section">
        <div className="folder-details-one-page-title">
          <Lab className="w-20 h-20" />
          {t("folder.questionnaire.sectionTitle")}
          {tabCounters.questionnaire > 0 && (
            <span className="item-counter-tag bg-background-secondary">
              {tabCounters.questionnaire}
            </span>
          )}
        </div>
        <FolderQuestionnaireLAB isOnePage />
      </div>
      <div className="folder-details-one-page-section mb-20">
        <div ref={diligencesTitleRef} className="folder-details-one-page-title mb-5">
          <Diligence className="w-20 h-20" />
          {t("folder.diligences.sectionTitle")}
        </div>
        <div className="ml-30 mb-10 text-xs font-light">
          <Trans
            i18nKey="folder.diligences.sectionDescription"
            components={{ strong: <strong className="font-medium" /> }}
          />
        </div>
        <FolderDiligences diligencesListRef={diligencesTitleRef} />
      </div>
      {documentToPreview && (
        <DocumentPreviewModal
          open={openDocumentPreviewModal}
          handleOpenChange={handleOpenDocumentPreviewModal}
          doc={documentToPreview}
        />
      )}
    </div>
  );
};
